import { render, staticRenderFns } from "./InformationLegal.vue?vue&type=template&id=dd798116&scoped=true"
import script from "./InformationLegal.vue?vue&type=script&lang=js"
export * from "./InformationLegal.vue?vue&type=script&lang=js"
import style0 from "./InformationLegal.vue?vue&type=style&index=0&id=dd798116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd798116",
  null
  
)

export default component.exports